export default __webpack_public_path__ + "static/media/Group 165.2b422732.png";